export default "__VITE_ASSET__BWV1XtqO__"